module.exports = __webpack_public_path__ + "static/img/14000016.ee9a2547.png";